var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 4C8.225 4 6.786 5.512 6.786 7.375V8.5h-.357C5.64 8.5 5 9.173 5 10v4.5c0 .827.64 1.5 1.429 1.5h7.142C14.36 16 15 15.327 15 14.5V10c0-.827-.64-1.5-1.429-1.5h-.357V7.375C13.214 5.512 11.774 4 10 4zm0 1.5c.987 0 1.786.84 1.786 1.875V8.5H8.214V7.375c0-1.036.8-1.875 1.786-1.875z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.22bb1028249b1b3046cebce4dbd5d4c1.svg";
export { ForwardRef as ReactComponent };